var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<span title=\""
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.AvgMonthlySalesLast12Months",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":13},"end":{"line":1,"column":58}}}))
    + "\" class=\"label marker-legend\">"
    + alias1(container.lambda(depth0, depth0))
    + "</span>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-stores-sales.hbs
// module id = f7VE
// module chunks = 1